import React, { useEffect, useRef, useCallback } from 'react';
import * as d3 from 'd3';
import { RADIUS, drawNetwork } from './drawNetwork';

export const NetworkDiagram = ({
  width,
  height,
  data,
  collideRadius,
  manyBodyStrength,
  forceYStrength,
  onNodeClick,
  selectedNode
}) => {
  const links = data.links.map((d) => ({ ...d }));
  const nodes = data.nodes.map((d) => ({ ...d }));
  const canvasRef = useRef(null);

  const handleClick = useCallback((event) => {
    const canvas = canvasRef.current;
    const rect = canvas.getBoundingClientRect();
    const x = event.clientX - rect.left;
    const y = event.clientY - rect.top;

    const node = nodes.find(n => {
      const dx = n.x - x;
      const dy = n.y - y;
      return dx * dx + dy * dy < RADIUS * RADIUS;
    });

    if (node) {
      onNodeClick(node);
    }
  }, [nodes, onNodeClick]);

  useEffect(() => {
    const canvas = canvasRef.current;
    const context = canvas?.getContext('2d');

    if (!context) {
      return;
    }

    const simulation = d3.forceSimulation(nodes)
      .force('link', d3.forceLink(links).id((d) => d.id))
      .force('collide', d3.forceCollide().radius(collideRadius).strength(1))
      .force('charge', d3.forceManyBody().strength(manyBodyStrength))
      .force('center', d3.forceCenter(width / 2, height / 2))
      .force('charge', d3.forceY(0).strength(forceYStrength))
      .on('tick', () => {
        drawNetwork(context, width, height, nodes, links, selectedNode);
      });

    canvas.addEventListener('click', handleClick);

    return () => {
      simulation.stop();
      canvas.removeEventListener('click', handleClick);
    };
  }, [width, height, nodes, links, collideRadius, manyBodyStrength, forceYStrength, handleClick]);

  return (
    <canvas
      ref={canvasRef}
      style={{ width: '100%', height: '100%', maxWidth: width, maxHeight: height }}
      width={width}
      height={height}
    />
  );
};